import ChartNivLongembolie from "../../../../src/client/niv_acuteboekje/json/verdenking-op-longembolie.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivLongembolie,
  ChartNivSimple,
  ButtonSchematic,
  React
};